<template>
  <div class="mb-0 table-responsive widget-list-custom" :class="{ 'widget-list-custom--empty': !table.showTable }">
    <table class="table b-table table-hover widget-table" v-if="table.showTable">
      <thead>
        <tr>
          <th v-for="(value, index) in table.fields" :key="index">
            <div v-html="value"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(value1, index1) in table.items" :key="index1">          
          <td v-for="(value2, elemento2, index2) in value1"
              :key="index2"
              class="align-middle"
              :data-label="fieldLabel(index2)">
            <div v-if="elemento2 != table.router.fieldValue" v-html="value2"></div>
            <div v-else class="text-center">
              <b-link class="widget-table-action" :aria-label="routerActionLabel()" @click="irDetalle(value2)">
                  <small>
                    <span>{{ routerActionLabel() }}</span>
                    <AppIcon icon="chevron-double-right"></AppIcon>
                  </small>
              </b-link>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot class="widget-table-footer" v-if="table.footer">
        <tr>
          <th :colspan="table.fields.length" class="widget-table-footer-value">            
            {{ this.table.footer }}
          </th>
        </tr>
      </tfoot>      
    </table>    
    <WidgetEmptyState v-else :message="emptyMessage" :variant="emptyVariant" />
  </div>
</template>

<script>
  import WidgetEmptyState from './WidgetEmptyState'

  export default {
    components: { WidgetEmptyState },
    props: {
      data: {
        type: Object,
        required: true
      },
    },
    data(){
      return {  
        table: {
          items: [],
          fields: [],        
          router: [],
          footer: 0,
          showTable: false,
        },       
      }
    },
    mounted() {
      this.configWidget()
    },
    watch: {
      data: {
        handler: function(){
          this.configWidget()
        },
        deep: true,
      },
    },
    computed: {
      emptyVariant() {
        return this.data.empty_variant || this.data.variant || 'info'
      },
      emptyMessage() {
        if(typeof this.data.items === 'string') return this.data.items
        if(Array.isArray(this.data.items) && this.data.items.length === 0) {
          return 'No hay registros para mostrar.'
        }
        return 'No hay datos para mostrar.'
      },
    },
    methods: {
      routerActionLabel() {
        const router = this.table.router || {}
        if(router.label || router.actionLabel) return router.label || router.actionLabel

        const routeName = String(router.name || '').toLowerCase()
        if(routeName.includes('hour')) return 'Ver horas'
        if(routeName.includes('message') || routeName.includes('inbox') || routeName.includes('conversation')) return 'Ver conversación'
        if(routeName.includes('pricelist')) return 'Ver lista de precios'
        if(routeName.includes('reminder')) return 'Ver recordatorio'

        return 'Ver detalle'
      },
      fieldLabel(index) {
        const field = this.table.fields && this.table.fields[index]
        return String(field || 'Dato').replace(/<[^>]*>/g, '').trim() || 'Dato'
      },
      configWidget(){        
        if(!Array.isArray(this.data.items) || this.data.items.length === 0) {
          this.table.showTable = false        
        } else {
          this.table.showTable = true          
        } 

        this.table.fields = this.data.fields
        this.table.items = this.data.items   
        this.table.router = this.data.router      
        this.table.footer = this.data.footer 
      },  
      irDetalle(valueParam) {               
        var jsonParams= []
        jsonParams[this.table.router.param] = valueParam
        this.$router.push({ name: this.table.router.name, params: jsonParams})        
      }          
    }
  }
</script>

<style>
  .widget-list-custom {
    overflow: auto;
    max-height: 300px;
    border: 1px solid var(--app-color-border-strong);
    border-radius: 9px;
    background: var(--app-color-surface);
    box-shadow: 0 5px 16px rgba(11, 31, 59, 0.20);
  }
  .widget-list-custom--empty {
    overflow: visible;
    border: 0;
    background: transparent;
  }
  .widget-list-custom .widget-table {
    margin-bottom: 0;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
  }
  .widget-list-custom .widget-table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 9px 10px;
    border-top: 0;
    border-bottom: 2px solid var(--app-color-primary);
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }
  .widget-list-custom .widget-table td {
    padding: 9px 10px;
    border-top-color: var(--app-color-border);
    color: var(--app-color-text);
    font-weight: var(--app-font-medium);
  }
  .widget-list-custom .widget-table tbody tr:nth-child(even) { background: var(--app-color-surface-subtle); }
  .widget-list-custom .widget-table tbody tr {
    transition: background-color 0.12s ease;
  }
  .widget-list-custom .widget-table tbody tr:hover {
    background: var(--app-color-primary-soft);
  }
  .widget-list-custom .widget-table .widget-table-action {
    display: inline-flex;
    align-items: center;
    min-height: 30px;
    padding: 5px 9px;
    border: 1px solid var(--app-color-primary-200);
    border-radius: 7px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
    font-weight: var(--app-font-semibold);
    text-decoration: none;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
  }
  .widget-list-custom .widget-table .widget-table-action:hover,
  .widget-list-custom .widget-table .widget-table-action:focus {
    border-color: var(--app-color-primary);
    background: var(--app-color-primary);
    color: var(--app-color-on-primary);
    text-decoration: underline;
    transform: translateY(-1px);
  }
  .widget-list-custom .widget-table .widget-table-action small {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: inherit;
  }
  .widget-list-custom .widget-table .widget-table-action .app-icon {
    font-size: 0.9rem;
  }
  .widget-table-footer {
    position: sticky;
    bottom: 0;
    background: var(--app-color-surface);
    box-shadow: var(--app-shadow-sm);
  }
  .widget-table-footer-value {
    padding: 8px 10px !important;
    border-top: 1px solid var(--app-color-primary) !important;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
    font-size: var(--app-text-base);
    font-weight: var(--app-font-semibold);
    text-align: right;
  }
  @media (max-width: 767.98px) {
    .widget-list-custom {
      overflow: visible;
      max-height: none;
      border: 0;
      background: transparent;
    }
    .widget-list-custom--empty { border: 0; }
    .widget-list-custom .widget-table,
    .widget-list-custom .widget-table tbody,
    .widget-list-custom .widget-table tr,
    .widget-list-custom .widget-table td {
      display: block;
      width: 100%;
    }
    .widget-list-custom .widget-table thead {
      display: none;
    }
    .widget-list-custom .widget-table tbody tr {
      overflow: hidden;
      margin-bottom: 10px;
      border: 1px solid var(--app-color-border);
      border-radius: 9px;
      background: var(--app-color-surface);
      box-shadow: var(--app-shadow-sm);
    }
    .widget-list-custom .widget-table tbody tr:hover {
      background: var(--app-color-surface);
    }
    .widget-list-custom .widget-table td {
      display: grid;
      grid-template-columns: minmax(96px, 42%) minmax(0, 1fr);
      align-items: center;
      gap: 10px;
      min-height: 40px;
      padding: 8px 10px;
      border-top: 1px solid var(--app-color-border);
      overflow-wrap: anywhere;
      text-align: left !important;
    }
    .widget-list-custom .widget-table td:first-child {
      border-top: 0;
    }
    .widget-list-custom .widget-table td::before {
      display: flex;
      align-items: center;
      align-self: stretch;
      margin: -8px 0 -8px -10px;
      padding: 8px 10px;
      border-right: 1px solid var(--app-color-primary-200);
      background: var(--app-color-primary-soft);
      color: var(--app-color-primary-active);
      content: attr(data-label);
      font-size: 0.66rem;
      font-weight: var(--app-font-bold);
      letter-spacing: 0.04em;
      line-height: 1.2;
      text-transform: uppercase;
    }
    .widget-list-custom .widget-table td > div,
    .widget-list-custom .widget-table td > div * {
      min-width: 0;
      text-align: left !important;
    }
    .widget-list-custom .widget-table-footer,
    .widget-list-custom .widget-table-footer tr,
    .widget-list-custom .widget-table-footer th {
      display: block;
      width: 100%;
    }
    .widget-list-custom .widget-table-footer-value {
      margin-bottom: 10px;
      border: 1px solid var(--app-color-primary-200) !important;
      border-radius: 9px;
    }
  }
</style>
